var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.158 5a.82.82 0 0 0-.574.253L12 10.838 6.415 5.253a.822.822 0 1 0-1.162 1.163L10.837 12l-5.584 5.585a.823.823 0 1 0 1.162 1.162L12 13.163l5.584 5.584a.821.821 0 1 0 1.163-1.162L13.162 12l5.585-5.584A.822.822 0 0 0 18.158 5"
  })));
};
export { SvgClose as ReactComponent };